import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { ITask2ReportAvailableItems, ITask2ReportWidgetFilter } from '../fi-task-v2-report';
import { ISelectedFilterItem } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';
import { FiTaskV2ReportTableFilterHelperService } from '../services/fi-task-v2-report-table-filter-helper.service';
import { Animations } from '@fi-app/shared/utils/animations';
import { FiReportTableFilterBaseComponent } from '@fi-shared/fi-report-table-filter/fi-report-table-filter-base.component';
import { FiTaskReportType } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-enums';

@Component({
    selector: 'fi-task-v2-report-table-filter',
    templateUrl: './fi-task-v2-report-table-filter.component.html',
    styleUrl: './fi-task-v2-report-table-filter.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-report-table-filter' },
    standalone: false,
    animations: [Animations.fadeWidth(), Animations.fadeHeight()],
})
export class FiTaskV2ReportTableFilterComponent
    extends FiReportTableFilterBaseComponent<ITask2ReportWidgetFilter, ITask2ReportAvailableItems>
    implements OnChanges
{
    @Input({ required: true }) availableItems: ITask2ReportAvailableItems;
    @Input({ required: true }) widgetReportType: FiTaskReportType;
    @Input({ required: true }) isResetButtonVisible: boolean;
    @Input() isCustomWidget: boolean;

    constructor(
        injector: Injector,
        private fiTaskV2ReportTableFilterHelperService: FiTaskV2ReportTableFilterHelperService,
    ) {
        super(injector);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        let change = changes.availableItems;
        if (change) {
            // we need setTimeout, because updateMenusData should be called after FiReportTableFilterBaseComponent.ngOnInit (initMenusData)
            setTimeout(() => {
                this.fiTaskV2ReportTableFilterHelperService.updateMenusData(
                    this.menusData,
                    this.availableItems,
                    change.firstChange,
                );
                this.setSelectedFilterItems();
            });
        }
    }

    protected initMenusData(): void {
        this.menusData = this.fiTaskV2ReportTableFilterHelperService.getFilterMenusData({
            widgetReportType: this.widgetReportType,
        });
    }

    protected setSelectedFilterItems(): void {
        this.selectedFilterItems = this.getSelectedFilterItemsFromFilter(this.currentFilter);
    }

    protected getSelectedFilterItemsFromFilter(filter: ITask2ReportWidgetFilter): ISelectedFilterItem[] {
        return this.fiTaskV2ReportTableFilterHelperService.getSelectedFilterItemsFromFilter(
            filter,
            this.availableItems,
        );
    }

    protected setSelectedMenuItems(): void {
        /*this.menusData = */ this.fiTaskV2ReportTableFilterHelperService.updatedMenusDataWithSelectedItems(
            this.menusData,
            this.selectedFilterItemsGroups,
        );
        /*this.cdr.markForCheck();*/
    }

    protected getFilterFromSelectedItems(
        selectedFilterItemsGroups: { [key: number]: ISelectedFilterItem[] },
        currentFilter: ITask2ReportWidgetFilter,
    ): ITask2ReportWidgetFilter {
        return this.fiTaskV2ReportTableFilterHelperService.getFilterFromSelectedItems(
            selectedFilterItemsGroups,
            currentFilter,
        );
    }

    protected selectFilter(filterGuid: string): void {
        this.onSelectFilter.emit(filterGuid);
    }

    protected updateCurrentFilter(): void {
        this.onUpdateCurrentFilter.emit();
    }

    protected isUpdateButtonVisible(): boolean {
        return this.isFilterChanged && this.currentFilter.Guid?.length && !this.isCustomWidget;
    }
}
